import HWLocalStorage from "./HWLocalStorage";
import { isAnyEmpty } from "./HWUtils.jsx";
import { s360ConfigService } from "../Services/S360Config";

class HWUser {
  static userInfoStorageKey = () => {
    return s360ConfigService.clientHostId + "-s360-user";
  };

  static user = () => {
    if (!s360ConfigService.isClientHostConfigured()) {
      return null;
    }
    let cachedUser = HWLocalStorage.load(this.userInfoStorageKey());
    if (!cachedUser) {
      return null;
    }
    return cachedUser;
  };

  static resetUser = () => {
    if (!s360ConfigService.isClientHostConfigured()) {
      return null;
    }
    HWLocalStorage.clearWithPrefix(s360ConfigService.clientHostId);
  };

  static updateUserDetails(userDetails) {
    if (!s360ConfigService.isClientHostConfigured()) {
      return null;
    }
    HWLocalStorage.save(userDetails, this.userInfoStorageKey());
  }

  static isLoggedIn = () => {
    let user = this.user();
    return (
      (user && isAnyEmpty(user.clientUser, user.clientPass) !== true) || false
    );
  };

  static xmppUserName = () => {
    let userData = this.user();
    return userData ? userData.clientUser : null;
  };

  static sourceType = () => {
    let userData = this.user();
    return userData ? userData.sourceType : null;
  };

  static sourceId = () => {
    let userData = this.user();
    return userData ? userData.sourceId : null;
  };

  static appId = () => {
    let userData = this.user();
    return userData ? userData.appId : null;
  };

  static customerId = () => {
    let userData = this.user();
    return userData ? userData.customerId : null;
  };

  static customerFirstName = () => {
    let userData = this.user();
    return userData ? userData.customerFirstName : null;
  };

  static customerLastName = () => {
    let userData = this.user();
    return userData ? userData.customerLastName : null;
  };

  static pageName = () => {
    let userData = this.user();
    return userData ? userData.pageName : null;
  };

  static xmppUserPassword = () => {
    let userData = this.user();
    return userData ? userData.clientPass : null;
  };
}

export default HWUser;
